import {useBlockProps, RichText, InspectorControls} from '@wordpress/block-editor';
import {__} from '@wordpress/i18n';
import { useSelect } from "@wordpress/data";
import {PanelBody,SelectControl,ToggleControl} from '@wordpress/components';

export default function Edit(props){
    const blockProps = useBlockProps();
    const postsTyps = useSelect((select) => {
        const data = select('core').getEntityRecords('root','postType',{
            per_page:-1
        });
        return data?.filter((item) =>
            item.visibility.show_in_nav_menus && item.visibility.show_ui);
    });
   // console.log(postsTyps);

    const posts = useSelect((select) => {
        const data = select("core").getEntityRecords("postType",
            props.attributes.postType,
            {
            per_page:-1
            }
        );
        return data;
    },[props.attributes.postType]);
    console.log(posts);
    return (
        <>
        <InspectorControls>
            <PanelBody title={__('Button Settings','fse-blocks')}>
                <SelectControl
                    label={__('Post Type','fse-blocks')}
                    value={props.attributes.postType}
                    onChange={(value)=>{
                        props.setAttributes({
                            postType:value
                        })
                    }}
                    options={[{
                        label:__('Select Post Type','fse-blocks'),
                        value:''
                    },...(postsTyps || []).map((postType =>(
                        {
                            label:postType.labels.singular_name,
                            value:postType.slug
                        }
                    ))
                
                )]}
                  
                />
                {!!props.attributes.postType &&
                <SelectControl
                    label={__(`Select ${props.attributes.postType} Url`,'fse-blocks')}
                    value={props.attributes.posturl}
                    onChange={(value)=>{
                        props.setAttributes({
                            posturl:value? value: null
                        })
                    }}
                    options={[{
                        label: __( `Select ${props.attributes.postType} for link`, 'fse-blocks' ),
                        value:''
                    },...(posts || []).map((post =>(
                        {
                            label:post.title.rendered,
                            value:post.slug
                        }
                    ))
                
                )]}
                />
                 }
                <ToggleControl 
                label={__('Open in new tab','fse-blocks')}
                checked={props.attributes.linkTarget}
                onChange={(value)=>{
                    props.setAttributes({
                        linkTarget:value
                    })
                }}
                />
               
            </PanelBody>
        </InspectorControls>
    <div {...blockProps}>
        <RichText 
        placeholder={__('Button text','fse-blocks')} 
        value={props.attributes.buttonText} 
        allowedFormats={[]}
        multiline={false}
        onReplace={()=>{}}
        onChange={(newValue)=>{
        props.setAttributes({buttonText:newValue})
    }} /></div>
    </>
    )
}